module.exports = "/build/web/images/errors/error_ball.2f1cc7665d1ebe61b2bbce01b08a517a.png";


//////////////////
// WEBPACK FOOTER
// ./images/errors/error_ball.png
// module id = 120
// module chunks = 24